import { LayersDictState } from '@/redux/layers/layers.types';
import { LayerOvalAdapter } from '@/utils/layer/LayerOvalAdapter';

export default function setLayerOval({
  layerId,
  layers,
  layerOval,
}: {
  layerId: number;
  layers: LayersDictState;
  layerOval: LayerOvalAdapter;
}): void {
  const layer = layers[layerId];
  if (!layer) {
    return;
  }
  layer.ovals[layerOval.getOriginalId()] = layerOval;
}
